import "animate.css";
import { closeLoading, Formatter, MIME_TYPE, openFile, useApiCallback, useSelector } from "gf-ui";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FaCheckCircle, FaEdit, FaFrown, FaInfoCircle, FaMeh, FaSignOutAlt, FaSmile, FaTimesCircle } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { formattaOrario, PAGINE, TIPOLOGIE } from ".";
import apiQuestionario from "../api/apiQuestionario";
import Agenda from '../components/Agenda';
import Footer from "../components/Footer";
import PageContainer from "../components/PageContainer";
import HeaderColon from "./coloneRetto/components/HeaderColon";
import HeaderSenologia from "./senologia/components/HeaderSenologia";
import HeaderTicketPsStranieri from "./ticketPsStranieri/components/HeaderTicketPsStranieri";

const Risultato = ({ tipologia }) => {
    const pageData = useSelector(state => state.page.data)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const apiCallback = useApiCallback()
    const _apiQuestionario = useRef(new apiQuestionario(dispatch, apiCallback, null))
    const shouldInit = useRef(true)
    _apiQuestionario.current.setFixedParams({ ID_TIPOLOGIA: tipologia.KID })  

    const header = useMemo(() => {
        if (tipologia) {
            switch (tipologia.KID) {
                case TIPOLOGIE.SENOLOGIA.KID: return <HeaderSenologia subtitle="Risultato" />;
                case TIPOLOGIE.COLON_RETTO.KID: return <HeaderColon subtitle="Risultato" />;
                case TIPOLOGIE.TICKET_PS_STRANIERI.KID: return <HeaderTicketPsStranieri subtitle="Risultato" />;
                default: return
            }
        }
    }, [tipologia])

    const [agenda, setAgenda] = useState({
        giorno: "",
        orario: ""
    });

    const termina = (e) => {
        e.preventDefault();

        if ((agenda.giorno !== "" && agenda.orario !== "")) {

            const params = {
                GIORNO: Formatter.getDateToDb(agenda.giorno, false),
                ORARIO: agenda.orario
            }

            _apiQuestionario.current.fnTermina(location.state.ID_SCHEDA, () => {
                navigate(`/${tipologia.URL}${PAGINE.HOME.URL}`)
            }, params)

        } else {
            navigate(`/${tipologia.URL}${PAGINE.HOME.URL}`)
        }
    }

    const selectOrario = (giorno, orario) => {
        setAgenda({
            giorno: Formatter.getDateToView(giorno),
            orario: formattaOrario(orario)
        });
    }

    useEffect(() => {        
        if(shouldInit.current){
            shouldInit.current = false
            window.scrollTo(0, 0)   
            _apiQuestionario.current.fnStampa((status, res) => {
                closeLoading(dispatch)
                if(status){
                    openFile(res.base64, Object.keys(MIME_TYPE.PDF)[0])                
                }
            }, { ID_BLOB: location.state.idBlob })
        }             
    }, [dispatch, location.state])

    return <PageContainer tipologia={tipologia}>
        <Container className="border bg-white p-0 rounded overflow-hidden">
            {header}

            <div className="text-center px-md-4">
                <div>
                    {location.state.cssClass === "success" && (
                        <span style={{ fontSize: '160px' }} >
                            <FaSmile className="text-success" />
                            <h1 className="text-success">{location.state.msg}</h1>
                        </span>
                    )}
                    {location.state.cssClass === "warning" && (
                        <span style={{ fontSize: '160px' }} >
                            <FaMeh className="text-warning" />
                            <h1 className="text-warning">{location.state.msg}</h1>
                        </span>
                    )}
                    {location.state.cssClass === "danger" && (
                        <span style={{ fontSize: '160px' }} >
                            <FaFrown className="text-danger" />
                            <h1 className="text-danger">{location.state.msg}</h1>
                        </span>
                    )}
                </div>
            </div>
            <div className={`text-left p-md-4 `}>
                <Form onSubmit={(e) => termina(e)}>
                    <Form.Group className="form-group text-left bg-light border">
                        <h4>
                            <Row>
                                <Col xs={1} className="text-center"><FaCheckCircle color="green" /></Col>
                                <Col xs={11}><label>{pageData?.ETICHETTE?.scheda_salvata} <strong>{location.state.NUMERO_ANNO}</strong></label></Col>
                            </Row>
                            {location.state.MEX_NUMERO_NOTA && <Row className="mt-4">
                                <Col xs={1} className="text-center"><FaEdit color="coral" /></Col>
                                <Col xs={11}><label><u>{location.state?.MEX_NUMERO_NOTA || ""}</u></label></Col>
                            </Row>}
                            {location?.state?.MESSAGGI?.map((messaggio, idx_msg) =>
                                <Row key={idx_msg} className="mt-4">
                                    <Col xs={1} className="text-center"><FaInfoCircle color="steelblue" /></Col>
                                    <Col xs={11}><label>{messaggio}</label></Col>
                                </Row>
                            )}
                        </h4>

                        {location?.state?.AGENDA && Object.keys(location?.state?.AGENDA).length > 0 && (
                            <div className="mt-4" style={{ paddingTop: 50, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                <Agenda dati={location.state.AGENDA}
                                    selectOrario={selectOrario}
                                    agenda={agenda} />

                                {agenda.giorno !== "" && (
                                    <div style={{ width: '100%' }} className="p-4 d-flex flex-column align-items-center justify-content-center">
                                        <span style={{ fontSize: '1.2em', fontWeight: 800 }} className="text-center text-md-left">Giorno / orario selezionati: </span>
                                        <span style={{ fontSize: '1.2em' }}>Giorno: <strong className="animate__animated animate__wobble">{agenda.giorno}</strong></span>
                                        <span style={{ fontSize: '1.2em' }}>Orario: <strong className="animate__animated animate__heartBeat">{agenda.orario}</strong></span>
                                        <Button variant="outline-danger" className="mt-2" onClick={() => setAgenda({ giorno: "", orario: "" })}><FaTimesCircle /> Cancella</Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </Form.Group>

                    <div className="d-grid gap-2">
                        <Button type="submit"
                            variant="outline-primary"
                            className="btn-lg"
                        ><FaSignOutAlt /> {pageData?.ETICHETTE?.termina}
                        </Button>
                    </div>
                </Form>
            </div>

            <Footer tipologia={tipologia} />

        </Container>
    </PageContainer>
}

export default Risultato;
